import { TTClient } from "./tt/ttclient.js";
import { TankTrouble } from "./tanktrouble.js";
import { animate, utils } from "animejs";
import { Backend } from "./backend.js";
import { Caches } from "./caches.js";
import { ClientManager } from "./clientmanager.js";
import { GameSession } from "./gamesession.js";
import { Images } from "./images.js";
import { OverlayManager } from "./overlaymanager.js";
import { UIConstants } from "./tt/ui/uiconstants.js";
import { UITankIcon } from "./tt/ui/uitankicon.js";
import { UIUtils } from "./tt/ui/uiutils.js";
import { Users } from "./users.js";
import { Utils } from "./utils.js";

TankTrouble.TankInfoBox = {
    // jQuery objects.
    info: null,
    infoIconPlaceholder: null,
    infoIcon: null,
    infoContent: null,
    infoTabLeft: null,
    infoTabRight: null,
    infoTabBottom: null,
    infoName: null,
    infoNameText: null,
    infoRank: null,
    infoRankTitle: null,
    infoRankTitleSvg: null,
    infoRankIcon: null,
    infoRankGuestIcon: null,
    infoRankProgress: null,
    infoRankProgressBorder: null,
    infoRankProgressBar: null,
    infoXP: null,
    infoXPTitle: null,
    infoXPTitleSvg: null,
    infoXPProgress: null,
    infoXPProgressBorder: null,
    infoXPProgressBar: null,
    infoTable: null,
    infoKillsAndVictoriesTableRow: null,
    infoKillsTableCell: null,
    infoKillsIcon: null,
    infoKills: null,
    infoKillsSvg: null,
    infoVictoriesTableCell: null,
    infoVictoriesIcon: null,
    infoVictories: null,
    infoVictoriesSvg: null,
    infoGoldAndDiamondTableRow: null,
    infoGoldTableCell: null,
    infoGoldIcon: null,
    infoGold: null,
    infoGoldSvg: null,
    infoDiamondTableCell: null,
    infoDiamondIcon: null,
    infoDiamondGlow: null,
    infoDiamondFirstRay: null,
    infoDiamondSecondRay: null,
    infoDiamond: null,
    infoDimaondSvg: null,
    infoActionsCentred: null,
    infoAdminLookup: null,
    infoFavouriteStarOn: null,
    infoFavouriteStarOff: null,
    infoGameJoin: null,
    infoGameJoinQueue: null,
    infoChat: null,
    infoActions: null,
    infoSignUp: null,
    infoShop: null,
    infoGarage: null,
    infoAchievements: null,
    infoAchievementsUnseenMarkerIcon: null,
    infoMazeCreator: null,
    infoAccount: null,
    infoAdmin: null,
    infoLogOut: null,
    infoBackground: null,

    // Canvas element.
    iconCanvas: null,

    // Animation timeouts.
    diamondSparkleTimeout: null,
    goldSparkleTimeout: null,
    flickerTimeout: null,

    // State.
    initialised: false,
    showing: false,
    playerId: null,
    username: null,

    // Events.
    eventListeners: [],
    EVENTS: {
        OPENED: "opened",
        CLOSED: "closed"
    },

    _initialise() {
        this.info = $("<div class='box noselect' id='tankinfo'/>");
        // FIXME: Remember to update stylesheet if size of tank info box is changed.
        this.infoIcon = $("<canvas class='icon'/>");
        this.iconCanvas = this.infoIcon[0];
        this.infoIconPlaceholder = $(`<img class='icon' src='${UITankIcon.getImageUrl("placeholder", UIConstants.TANK_ICON_SIZES.LARGE)}' alt=''/>`);
        this.infoContent = $("<div class='content'/>");
        this.infoTabLeft = $("<div class='tab left'/>");
        this.infoTabRight = $("<div class='tab right'/>");
        this.infoTabBottom = $("<div class='tab bottom'/>");
        this.infoName = $("<div class='username'/>");
        this.infoRank = $("<div class='rank'/>");
        this.infoRankTitle = $("<div class='title'/>");
        this.infoRankIcon = $(`<img class='rankIcon' ${Images.attributes("atlases/ranks/0.png")}/>`);
        this.infoRankGuestIcon = $(`<img class='rankIcon' ${Images.attributes("atlases/ranks/guest.png")}/>`);
        this.infoRankProgress = $("<div class='progress'/>");
        this.infoRankProgressBorder = $("<div class='border'/>");
        this.infoRankProgressBar = $("<div class='bar'/>");
        this.infoXP = $("<div class='xp'/>");
        this.infoXPTitle = $("<div class='title'/>");
        this.infoXPProgress = $("<div class='progress'/>");
        this.infoXPProgressBorder = $("<div class='border'/>");
        this.infoXPProgressBar = $("<div class='bar'/>");
        this.infoTable = $("<table/>");
        this.infoKillsAndVictoriesTableRow = $("<tr/>");
        this.infoKillsTableCell = $("<td/>");
        this.infoKillsIcon = $(`<img class='statsIcon' ${Images.attributes("tankInfo/kills.png")}/>`);
        this.infoKills = $("<div/>");
        this.infoVictoriesTableCell = $("<td/>");
        this.infoVictoriesIcon = $(`<img class='statsIcon' ${Images.attributes("tankInfo/victories.png")}/>`);
        this.infoVictories = $("<div/>");
        this.infoGoldAndDiamondTableRow = $("<tr/>");
        this.infoGoldTableCell = $("<td/>");
        this.infoGoldIcon = $(`<img class='statsIcon' ${Images.attributes("tankInfo/gold.png")}/>`);
        this.infoGold = $("<div/>");
        this.infoDiamondTableCell = $("<td/>");
        this.infoDiamondIcon = $(`<img class='statsIcon' ${Images.attributes("tankInfo/diamond.png")}/>`);
        this.infoDiamondGlow = $(`<img class='glow' ${Images.attributes("tankInfo/diamondGlow.png")}/>`);
        this.infoDiamondFirstRay = $(`<img class='ray first' ${Images.attributes("tankInfo/diamondRays.png")}/>`);
        this.infoDiamondSecondRay = $(`<img class='ray second' ${Images.attributes("tankInfo/diamondRays.png")}/>`);
        this.infoDiamond = $("<div/>");
        this.infoActionsCentred = $("<div class='actions centred'/>");
        this.infoAdminLookup = $("<div class='button' title=''/>");
        this.infoFavouriteStarOn = $("<div class='button' title=''/>");
        this.infoFavouriteStarOff = $("<div class='button' title=''/>");
        this.infoGameJoin = $("<div class='button' title=''/>");
        this.infoGameJoinQueue = $("<div class='button' title=''/>");
        this.infoChat = $("<div class='button' title=''/>");
        this.infoActions = $("<div class='actions'/>");
        this.infoSignUp = Utils.createFixedWidthButton("Sign up now", "medium", 198);
        this.infoShop = $("<div class='button shop' title=''/>");
        this.infoGarage = $("<div class='button' title=''/>");
        this.infoAchievements = $("<div class='button' title=''/>");
        this.infoAchievementsUnseenMarkerIcon = $(`<img class='buttonMarker' ${Images.attributes("tankInfo/unseenMarker.png")}/>`);
        this.infoMazeCreator = $("<div class='button' title=''/>");
        this.infoAccount = $("<div class='button' title=''/>");
        this.infoAdmin = $("<div class='button' title=''/>");
        this.infoLogOut = $("<div class='button' title=''/>");
        this.infoBackground = $("<div class='boxbackground'/>");

        this.infoContent.append(this.infoTabLeft);
        this.infoContent.append(this.infoTabRight);
        this.infoContent.append(this.infoTabBottom);

        this.infoRankProgress.append(this.infoRankProgressBorder);
        this.infoRankProgress.append(this.infoRankProgressBar);
        this.infoRank.append(this.infoRankProgress);
        this.infoRank.append(this.infoRankGuestIcon);
        this.infoRank.append(this.infoRankIcon);
        this.infoRank.append(this.infoRankTitle);

        this.infoXPProgress.append(this.infoXPProgressBorder);
        this.infoXPProgress.append(this.infoXPProgressBar);
        this.infoXP.append(this.infoXPProgress);
        this.infoXP.append(this.infoXPTitle);

        this.infoKillsTableCell.append(this.infoKillsIcon);
        this.infoKillsTableCell.append(this.infoKills);
        this.infoVictoriesTableCell.append(this.infoVictoriesIcon);
        this.infoVictoriesTableCell.append(this.infoVictories);
        this.infoKillsAndVictoriesTableRow.append(this.infoKillsTableCell);
        this.infoKillsAndVictoriesTableRow.append(this.infoVictoriesTableCell);

        this.infoGoldTableCell.append(this.infoGoldIcon);
        this.infoGoldTableCell.append(this.infoGold);
        this.infoDiamondTableCell.append(this.infoDiamondGlow);
        this.infoDiamondTableCell.append(this.infoDiamondFirstRay);
        this.infoDiamondTableCell.append(this.infoDiamondSecondRay);
        this.infoDiamondTableCell.append(this.infoDiamondIcon);
        this.infoDiamondTableCell.append(this.infoDiamond);
        this.infoGoldAndDiamondTableRow.append(this.infoGoldTableCell);
        this.infoGoldAndDiamondTableRow.append(this.infoDiamondTableCell);

        this.infoTable.append(this.infoKillsAndVictoriesTableRow);
        this.infoTable.append(this.infoGoldAndDiamondTableRow);

        Utils.addImageWithClasses(this.infoAdminLookup, "standard", "tankInfo/admin.png");
        Utils.addImageWithClasses(this.infoAdminLookup, "active", "tankInfo/adminActive.png");
        Utils.addImageWithClasses(this.infoAdminLookup, "disabled", "tankInfo/adminDisabled.png");
        Utils.addImageWithClasses(this.infoFavouriteStarOn, "standard", "tankInfo/favouriteOn.png");
        Utils.addImageWithClasses(this.infoFavouriteStarOn, "active", "tankInfo/favouriteOnActive.png");
        Utils.addImageWithClasses(this.infoFavouriteStarOn, "disabled", "tankInfo/favouriteDisabled.png");
        Utils.addImageWithClasses(this.infoFavouriteStarOff, "standard", "tankInfo/favouriteOff.png");
        Utils.addImageWithClasses(this.infoFavouriteStarOff, "active", "tankInfo/favouriteOffActive.png");
        Utils.addImageWithClasses(this.infoFavouriteStarOff, "disabled", "tankInfo/favouriteDisabled.png");
        Utils.addImageWithClasses(this.infoGameJoin, "standard", "tankInfo/join.png");
        Utils.addImageWithClasses(this.infoGameJoin, "active", "tankInfo/joinActive.png");
        Utils.addImageWithClasses(this.infoGameJoin, "disabled", "tankInfo/joinDisabled.png");
        Utils.addImageWithClasses(this.infoGameJoinQueue, "standard", "tankInfo/joinQueue.png");
        Utils.addImageWithClasses(this.infoGameJoinQueue, "active", "tankInfo/joinQueueActive.png");
        Utils.addImageWithClasses(this.infoGameJoinQueue, "disabled", "tankInfo/joinDisabled.png");
        Utils.addImageWithClasses(this.infoChat, "standard", "tankInfo/chat.png");
        Utils.addImageWithClasses(this.infoChat, "active", "tankInfo/chatActive.png");
        Utils.addImageWithClasses(this.infoChat, "disabled", "tankInfo/chatDisabled.png");
        Utils.addImageWithClasses(this.infoShop, "standard", "tankInfo/shop.png");
        Utils.addImageWithClasses(this.infoShop, "standard flicker", "tankInfo/shopFlicker.png");
        Utils.addImageWithClasses(this.infoShop, "active", "tankInfo/shopActive.png");
        Utils.addImageWithClasses(this.infoShop, "disabled", "tankInfo/shop.png");
        Utils.addImageWithClasses(this.infoGarage, "standard", "tankInfo/garage.png");
        Utils.addImageWithClasses(this.infoGarage, "active", "tankInfo/garageActive.png");
        Utils.addImageWithClasses(this.infoAchievements, "standard", "tankInfo/achievements.png");
        Utils.addImageWithClasses(this.infoAchievements, "active", "tankInfo/achievementsActive.png");
        Utils.addImageWithClasses(this.infoAchievements, "disabled", "tankInfo/achievements.png");
        Utils.addImageWithClasses(this.infoMazeCreator, "standard", "tankInfo/mazeCreator.png");
        Utils.addImageWithClasses(this.infoMazeCreator, "active", "tankInfo/mazeCreatorActive.png");
        Utils.addImageWithClasses(this.infoMazeCreator, "disabled", "tankInfo/mazeCreator.png");
        Utils.addImageWithClasses(this.infoAccount, "standard", "tankInfo/account.png");
        Utils.addImageWithClasses(this.infoAccount, "active", "tankInfo/accountActive.png");
        Utils.addImageWithClasses(this.infoAdmin, "standard", "tankInfo/admin.png");
        Utils.addImageWithClasses(this.infoAdmin, "active", "tankInfo/adminActive.png");
        Utils.addImageWithClasses(this.infoLogOut, "standard", "tankInfo/logOut.png");
        Utils.addImageWithClasses(this.infoLogOut, "active", "tankInfo/logOutActive.png");
        Utils.addImageWithClasses(this.infoLogOut, "disabled", "tankInfo/logOutDisabled.png");

        this.infoAchievements.append(this.infoAchievementsUnseenMarkerIcon);

        this.infoActionsCentred.append(this.infoAdminLookup);
        // TODO: Uncomment to re-engage favourite system. Also remove first line in TankTroubleJsonRpcServer:getFavourites()
        //this.infoActionsCentred.append(this.infoFavouriteStarOn);
        //this.infoActionsCentred.append(this.infoFavouriteStarOff);
        this.infoActionsCentred.append(this.infoGameJoin);
        this.infoActionsCentred.append(this.infoGameJoinQueue);
        this.infoActionsCentred.append(this.infoChat);
        this.infoActions.append(this.infoSignUp);
        this.infoActions.append(this.infoShop);
        this.infoActions.append(this.infoGarage);
        this.infoActions.append(this.infoAchievements);
        //this.infoActions.append(this.infoMazeCreator);
        this.infoActions.append(this.infoAccount);
        this.infoActions.append(this.infoAdmin);
        this.infoActions.append(this.infoLogOut);

        this.infoContent.append(this.infoName);
        this.infoContent.append(this.infoRank);
        this.infoContent.append(this.infoXP);

        this.infoContent.append(this.infoTable);
        this.infoContent.append(this.infoActionsCentred);
        this.infoContent.append(this.infoActions);

        this.info.append(this.infoContent);
        this.info.append(this.infoIcon);
        this.info.append(this.infoIconPlaceholder);

        $("body").append(this.infoBackground);
        $("body").append(this.info);

        this.infoBackground.hide();
        this.info.hide();

        this.infoIcon.hide();

        this.infoRank.tooltipster({ side: "right" });
        this.infoXP.tooltipster({ side: "right" });
        this.infoKillsTableCell.tooltipster({ side: "left" });
        this.infoVictoriesTableCell.tooltipster({ side: "right" });
        this.infoGoldTableCell.tooltipster({ side: "left" });
        this.infoDiamondTableCell.tooltipster({ side: "right" });
        this.infoAdminLookup.tooltipster({ side: "left" });
        this.infoFavouriteStarOn.tooltipster({ side: "left" });
        this.infoFavouriteStarOff.tooltipster({ side: "left" });
        this.infoGameJoin.tooltipster({ side: "top" });
        this.infoGameJoinQueue.tooltipster({ side: "top" });
        this.infoChat.tooltipster({ side: "right" });
        this.infoSignUp.tooltipster({ side: "top" });
        this.infoShop.tooltipster({ side: "left" });
        this.infoGarage.tooltipster({ side: "top" });
        this.infoAchievements.tooltipster({ side: "top" });
        this.infoMazeCreator.tooltipster({ side: "right" });
        this.infoAccount.tooltipster({ side: "top" });
        this.infoAdmin.tooltipster({ side: "top", distance: 12 });
        this.infoLogOut.tooltipster({ side: "right", theme: "tooltipster-error" });

        this.infoBackground.click(event => {
            if (this.showing) {
                this.hide();
            }
        });

        this.infoAdminLookup.on("mouseup", event => {
            if (this.showing) {
                if (!$(event.currentTarget).hasClass("disabled")) {
                    this._lookup();
                }
            }
        });

        this.infoFavouriteStarOn.on("mouseup", event => {
            if (this.showing) {
                if (!$(event.currentTarget).hasClass("disabled")) {
                    this._setFavourited(false);
                }
            }
        });

        this.infoFavouriteStarOff.on("mouseup", event => {
            if (this.showing) {
                if (!$(event.currentTarget).hasClass("disabled")) {
                    this._setFavourited(true);
                }
            }
        });

        this.infoGameJoin.on("mouseup", event => {
            if (this.showing) {
                if (!$(event.currentTarget).hasClass("disabled")) {
                    this.hide();
                    console.log("TODO: JOIN GAME");
                }
            }
        });

        this.infoGameJoinQueue.on("mouseup", event => {
            if (this.showing) {
                if (!$(event.currentTarget).hasClass("disabled")) {
                    this.hide();
                    console.log("TODO: JOIN GAME QUEUE");
                }
            }
        });

        this.infoChat.on("mouseup", event => {
            if (this.showing) {
                if (!$(event.currentTarget).hasClass("disabled")) {
                    this.hide();
                    TankTrouble.ChatBox.addRecipient(this.playerId);
                    TankTrouble.ChatBox.open();
                }
            }
        });

        this.infoSignUp.click(event => {
            if (this.showing) {
                this.hide();
                // Indicate to the sign up box that the current guest should be replaced.
                OverlayManager.pushOverlay(
                    TankTrouble.SignUpOverlay,
                    { guestPlayerIdToSignUp: this.playerId }
                );
            }
        });

        this.infoShop.on("mouseup", event => {
            if (this.showing) {
                this.hide();
                OverlayManager.pushOverlay(
                    TankTrouble.VirtualShopOverlay,
                    { playerId: this.playerId }
                );
            }
        });

        this.infoGarage.on("mouseup", event => {
            if (this.showing) {
                this.hide();
                OverlayManager.pushOverlay(
                    TankTrouble.GarageOverlay,
                    { playerId: this.playerId }
                );
            }
        });

        this.infoAchievements.on("mouseup", event => {
            if (this.showing) {
                this.hide();
                OverlayManager.pushOverlay(
                    TankTrouble.AchievementsOverlay,
                    { playerId: this.playerId }
                );
            }
        });

        this.infoMazeCreator.on("mouseup", event => {
            if (this.showing) {
                this.hide();
                console.log("TODO: OPEN MAZE CREATOR");
            }
        });

        this.infoAccount.on("mouseup", event => {
            if (this.showing) {
                this.hide();
                OverlayManager.pushOverlay(
                    TankTrouble.AccountOverlay,
                    { playerId: this.playerId }
                );
            }
        });

        // Set the canvas size.
        this.iconCanvas.width = UIConstants.TANK_ICON_WIDTHS[UIConstants.TANK_ICON_SIZES.LARGE];
        this.iconCanvas.height = UIConstants.TANK_ICON_HEIGHTS[UIConstants.TANK_ICON_SIZES.LARGE];

        // Place content according to UI constants.
        this.infoContent.css("width", UIConstants.TANK_INFO_WIDTH - 10);

        this.infoNameText = $(`<stroked-text width='${UIConstants.TANK_INFO_WIDTH - 10}' height='33' font-size='24' stroke-width='4'/>`);
        this.infoName.append(this.infoNameText);

        this.infoRankTitle.svg({ settings: { width: UIConstants.TANK_INFO_WIDTH - 10, height: 34 } });
        this.infoRankTitleSvg = this.infoRankTitle.svg("get");

        this.infoXPTitle.svg({ settings: { width: UIConstants.TANK_INFO_WIDTH - 10, height: 34 } });
        this.infoXPTitleSvg = this.infoXPTitle.svg("get");

        this.infoKills.svg({ settings: { width: UIConstants.TANK_INFO_MAX_NUMBER_WIDTH, height: 34 } });
        this.infoKillsSvg = this.infoKills.svg("get");

        this.infoVictories.svg({ settings: { width: UIConstants.TANK_INFO_MAX_NUMBER_WIDTH, height: 34 } });
        this.infoVictoriesSvg = this.infoVictories.svg("get");

        this.infoGold.svg({ settings: { width: UIConstants.TANK_INFO_MAX_NUMBER_WIDTH, height: 34 } });
        this.infoGoldSvg = this.infoGold.svg("get");

        this.infoDiamond.svg({ settings: { width: UIConstants.TANK_INFO_MAX_NUMBER_WIDTH, height: 34 } });
        this.infoDiamondSvg = this.infoDiamond.svg("get");

        this.initialised = true;
    },

    addEventListener(callback, context) {
        this.eventListeners.push({ callback, context });
    },

    removeEventListener(callback, context) {
        for (let i = 0; i < this.eventListeners.length; i++) {
            if (this.eventListeners[i].callback === callback && this.eventListeners[i].context === context) {
                // Remove single entry from array, and return immediately
                // as continuing iteration is unsafe, as the underlying array
                // has been modified
                this.eventListeners.splice(i, 1);
                return;
            }
        }
    },

    show(x, y, playerId, preferredRadiusHorizontal, preferredRadiusVertical, preferredDirections) {
        if (!this.initialised) {
            this._initialise();
        }

        if (preferredDirections === undefined) {
            preferredDirections = ["top", "right", "left", "bottom"];
        }

        this.playerId = playerId;
        this.username = null;

        // Update tool tips. We assume the player is a guest, and then we update tooltips later if not.
        this.infoRank.tooltipster("content", "Tank rank (0/100)");
        this.infoXP.tooltipster("content", "Tank level (0/100)");
        this.infoKillsTableCell.tooltipster("content", "Kills");
        this.infoVictoriesTableCell.tooltipster("content", "Victories");
        this.infoGoldTableCell.tooltipster("content", "Gold");
        this.infoDiamondTableCell.tooltipster("content", "Dimitrium");
        this.infoFavouriteStarOff.tooltipster("content", "Loading favourite information");
        this.infoGameJoin.tooltipster("content", "Loading battle information");
        this.infoChat.tooltipster("content", "Loading chat information");
        this.infoShop.tooltipster("content", "Dimitri's Emporium");
        this.infoGarage.tooltipster("content", "Customise your tank");
        this.infoAchievements.tooltipster("content", "Achievements");
        this.infoMazeCreator.tooltipster("content", "Maze creator");
        this.infoAccount.tooltipster("content", "Account info");
        this.infoAdmin.tooltipster("content", "Admin");
        this.infoSignUp.tooltipster("content", "Sign up to store your progress");
        this.infoLogOut.tooltipster("content", "WARNING: If you leave you will lose all progress with this guest");
        this.infoLogOut.tooltipster("option", "theme", "tooltipster-error");

        this.info.show();
        this.infoBackground.fadeIn(200);

        this.showing = true;

        // Place relevant buttons and info.
        this._hideAllButtonsAndInfo();
        this._showRelevantButtonsAndInfo();

        Utils.placeBoxBestLocation(this.info, x, y, preferredDirections, preferredRadiusHorizontal, preferredRadiusVertical, 30, 35, [150, 0, 0, 0]);

        // Setting the scale to 0 causes issues with svg text scale, so we work around that by setting the scale to 0.1.
        this.info.css({ opacity: 0 });
        utils.set(this.info[0], { scale: 0.1 });
        animate(this.info[0], { scale: 1, duration: 300, ease: "outBack" });
        this.info.animate({ opacity: 1 }, { duration: 200, queue: false });

        this.infoIconPlaceholder.show();
        this.infoIcon.hide();

        this.infoAchievementsUnseenMarkerIcon.hide();

        this.infoNameText.attr("text", "");
        this.infoRankTitleSvg.clear();
        this.infoXPTitleSvg.clear();
        this.infoKillsSvg.clear();
        this.infoVictoriesSvg.clear();

        // Send request for player details.
        Backend.getPlayerDetails(this.playerId, Caches.getPlayerDetailsCache())
            .then(result => {
                UITankIcon.loadPlayerTankIcon(this.iconCanvas, UIConstants.TANK_ICON_SIZES.LARGE, this.playerId).then(() => {
                    // Show icon.
                    this.infoIconPlaceholder.hide();
                    this.infoIcon.show();
                });

                this.username = "Scrapped";
                let victories = "N/A";
                let kills = "N/A";
                let guest = false;
                let rank = 0;
                let rankLevel = 0;
                let rankToRankDown = 0;
                let rankToRankUp = UIConstants.RANK_POINTS_PER_RANK_LEVEL;
                let rankTitle = "N/A";
                let rankImage = "0";
                let xp = 0;
                let level = 0;
                let [xpToLevelDown, xpToLevelUp] = UIConstants.XP_LEVELS;
                let levelTitle = "N/A";

                if (typeof result === "object") {
                    this.username = Utils.maskUnapprovedUsername(result);
                    victories = result.getVictories();
                    kills = result.getKills();

                    rank = result.getRank();
                    rankLevel = UIUtils.getRankLevelFromRank(rank);
                    rankToRankDown = rankLevel > 0 ? UIConstants.RANK_LEVELS[rankLevel - 1] : 0;
                    rankToRankUp = UIConstants.RANK_LEVELS[rankLevel];
                    rankTitle = UIConstants.RANK_TITLES[rankLevel];
                    rankImage = `${rankLevel}`;

                    xp = result.getXP();
                    level = UIUtils.getLevelFromXp(xp);
                    xpToLevelDown = level > 0 ? UIConstants.XP_LEVELS[level - 1] : 0;
                    xpToLevelUp = UIConstants.XP_LEVELS[level];
                    levelTitle = `Level ${level + 1}`;

                    // Update tool tips.
                    if (rankToRankUp === undefined) {
                        this.infoRank.tooltipster("content", `Rank (${rank})`);
                    } else {
                        this.infoRank.tooltipster("content", `Rank (${rank} / ${rankToRankUp})`);
                    }
                    if (xpToLevelUp === undefined) {
                        this.infoXP.tooltipster("content", `XP (${xp} / Maxed out)`);
                    } else {
                        this.infoXP.tooltipster("content", `XP (${xp} / ${xpToLevelUp})`);
                    }

                    this.infoAdminLookup.tooltipster("content", `Look up ${this.username}`);
                    this.infoFavouriteStarOn.tooltipster("content", `Remove ${this.username} from your favourites`);
                    this.infoFavouriteStarOff.tooltipster("content", `Add ${this.username} to your favourites`);
                    this.infoGameJoin.tooltipster("content", `Battle ${this.username}`);
                    this.infoGameJoinQueue.tooltipster("content", `Queue up to battle ${this.username}`);
                    this.infoChat.tooltipster("content", `Send message to ${this.username}`);
                    if (result.getGuest()) {
                        guest = true;
                    }

                    // Enable look up button.
                    this.infoAdminLookup.removeClass("disabled");

                    // Update log in/out.
                    this._updateLogInAndOutStatus();

                    // Check if I'm a favourite.
                    this._updateFavouriteStatus();

                    // Check if I can be joined in a game.
                    this._updateJoinGameStatus();

                    // Check if I can be chatted to.
                    this._updateChatStatus();
                } else {
                    // Update tool tips.
                    this.infoRank.tooltipster("content", "Could not retrieve this tank's rank");
                    this.infoXP.tooltipster("content", "Could not retrieve this tank's XP");
                    this.infoAdminLookup.tooltipster("content", "You cannot currently look up this tank");
                    this.infoFavouriteStarOn.tooltipster("content", "You cannot currently remove this tank from your favourites");
                    this.infoFavouriteStarOff.tooltipster("content", "You cannot currently add this tank to your favourites");
                    this.infoGameJoin.tooltipster("content", "You cannot currently battle this tank");
                    this.infoGameJoinQueue.tooltipster("content", "You cannot currently battle this tank");
                    this.infoChat.tooltipster("content", "You cannot currently message this tank");
                }

                // Update name.
                this.infoNameText.attr("text", this.username);

                // Update rank title, rank icon, guest icon and progress
                let rankWidth = this.infoRankTitleSvg.text(18 + 2, 22, rankTitle, { textAnchor: "left", fontFamily: "Arial", fontWeight: "bold", fontSize: 14, fill: "none", stroke: "black", strokeLineJoin: "round", strokeWidth: 3 }).getComputedTextLength();
                this.infoRankTitleSvg.text(18 + 2, 22, rankTitle, { textAnchor: "left", fontFamily: "Arial", fontWeight: "bold", fontSize: 14, fill: "white" });
                rankWidth += 4; // Account for stroke

                if (guest) {
                    this.infoRankGuestIcon.show();
                    let guestWidth = this.infoRankTitleSvg.text(18 + rankWidth + 18 + 2, 22, "Guest", { textAnchor: "left", fontFamily: "Arial", fontWeight: "bold", fontSize: 14, fill: "none", stroke: "black", strokeLineJoin: "round", strokeWidth: 3 }).getComputedTextLength();
                    this.infoRankTitleSvg.text(18 + rankWidth + 18 + 2, 22, "Guest", { textAnchor: "left", fontFamily: "Arial", fontWeight: "bold", fontSize: 14, fill: "white" });
                    guestWidth += 4;    // Account for stroke
                    this.infoRankTitleSvg.configure({ width: 18 + rankWidth + 18 + guestWidth });
                } else {
                    this.infoRankGuestIcon.hide();
                    this.infoRankTitleSvg.configure({ width: 18 + rankWidth });
                }

                this.infoRankTitle.css("left", (this.infoRank.width() / 2) - (this.infoRankTitleSvg.width() / 2));

                this.infoRankIcon.attr("src", Images.url(`atlases/ranks/${rankImage}.png`));
                this.infoRankIcon.css("left", (this.infoRank.width() / 2) - (this.infoRankTitleSvg.width() / 2) - 2);

                this.infoRankGuestIcon.css("left", (this.infoRank.width() / 2) - (this.infoRankTitleSvg.width() / 2) + 18 + rankWidth);

                if (rankToRankUp === undefined) {
                    this.infoRankProgressBar.css("width", "100%");
                } else {
                    this.infoRankProgressBar.css("width", `${((rank - rankToRankDown) / (rankToRankUp - rankToRankDown)) * 100}%`);
                }

                // Update XP title and progress
                this.infoXPTitleSvg.text(this.infoXPTitle.width() / 2, 22, levelTitle, { textAnchor: "middle", fontFamily: "Arial", fontWeight: "bold", fontSize: 14, fill: "none", stroke: "black", strokeLineJoin: "round", strokeWidth: 3 });
                this.infoXPTitleSvg.text(this.infoXPTitle.width() / 2, 22, levelTitle, { textAnchor: "middle", fontFamily: "Arial", fontWeight: "bold", fontSize: 14, fill: "white" });

                if (xpToLevelUp === undefined) {
                    this.infoXPProgressBar.css("width", "100%");
                } else {
                    this.infoXPProgressBar.css("width", `${((xp - xpToLevelDown) / (xpToLevelUp - xpToLevelDown)) * 100}%`);
                }

                // Update kills and victories.
                const killsTextOutline = this.infoKillsSvg.text(1, 22, kills.toString(), { textAnchor: "start", fontFamily: "Arial Black", fontSize: 14, fill: "none", stroke: "black", strokeLineJoin: "round", strokeWidth: 3, letterSpacing: 1 });
                const killsText = this.infoKillsSvg.text(1, 22, kills.toString(), { textAnchor: "start", fontFamily: "Arial Black", fontSize: 14, fill: "white", letterSpacing: 1 });

                const killsLength = Utils.measureSVGText(kills.toString(), { fontFamily: "Arial Black", fontSize: 14 });

                // Plus seven to account for stroke width.
                let scaleAndTranslate = Utils.getSVGScaleAndTranslateToFit(UIConstants.TANK_INFO_MAX_NUMBER_WIDTH, killsLength + 7, 34, "left");

                this.infoKillsSvg.configure(killsTextOutline, { transform: scaleAndTranslate });
                this.infoKillsSvg.configure(killsText, { transform: scaleAndTranslate });

                const victoriesTextOutline = this.infoVictoriesSvg.text(UIConstants.TANK_INFO_MAX_NUMBER_WIDTH - 1, 22, victories.toString(), { textAnchor: "end", fontFamily: "Arial Black", fontSize: 14, fill: "none", stroke: "black", strokeLineJoin: "round", strokeWidth: 3, letterSpacing: 1 });
                const victoriesText = this.infoVictoriesSvg.text(UIConstants.TANK_INFO_MAX_NUMBER_WIDTH - 1, 22, victories.toString(), { textAnchor: "end", fontFamily: "Arial Black", fontSize: 14, fill: "white", letterSpacing: 1 });

                const victoriesLength = Utils.measureSVGText(victories.toString(), { fontFamily: "Arial Black", fontSize: 14 });

                // Plus seven to account for stroke width.
                scaleAndTranslate = Utils.getSVGScaleAndTranslateToFit(UIConstants.TANK_INFO_MAX_NUMBER_WIDTH, victoriesLength + 7, 34, "right");

                this.infoVictoriesSvg.configure(victoriesTextOutline, { transform: scaleAndTranslate });
                this.infoVictoriesSvg.configure(victoriesText, { transform: scaleAndTranslate });
            });

        Backend.getUnseenAchievements(this.playerId, Caches.getUnseenAchievementsCache())
            .then(result => {
                if (Array.isArray(result)) {
                    if (result.length > 0) {
                        utils.remove(this.infoAchievementsUnseenMarkerIcon[0]);
                        this.infoAchievementsUnseenMarkerIcon.show();
                        utils.set(this.infoAchievementsUnseenMarkerIcon[0], { scale: 0, rotate: 0 });
                        animate(this.infoAchievementsUnseenMarkerIcon[0], {
                            keyframes: [
                                { scale: 1.5, rotate: 0, duration: 200 },
                                { scale: 1, rotate: 0, duration: 250 }
                            ],
                            delay: 500,
                            ease: UIConstants.EASE_DEFAULT,
                            onComplete: () => {
                                this._loopButtonMarkerAnimation();
                            }
                        });
                        // Update tool tips.
                        this.infoAchievements.tooltipster("content", `You have unlocked ${result.length} new achievement${result.length > 1 ? "s" : ""}`);
                    }
                }
            });

        GameSession.disableGameInput();

        ClientManager.getClient().addEventListener(this._clientEventHandler, this);

        this._notifyEventListeners(TankTrouble.TankInfoBox.EVENTS.OPENED, this.playerId);
    },

    hide() {
        if (!this.initialised) {
            this._initialise();
        }

        animate(this.info[0], {
            scale: 0,
            duration: 200,
            ease: "inQuad",
            onComplete: () => {
                this.info.hide();
                utils.set(this.info[0], { scale: 1 });
            }
        });
        this.info.animate({ opacity: 0 }, { duration: 200, queue: false });

        this.infoBackground.fadeOut(200);

        this.showing = false;

        utils.remove(this.infoAchievementsUnseenMarkerIcon[0]);

        GameSession.enableGameInput();

        ClientManager.getClient().removeEventListener(this._clientEventHandler, this);

        this._notifyEventListeners(TankTrouble.TankInfoBox.EVENTS.CLOSED, this.playerId);
    },

    isShowing() {
        return this.showing;
    },

    getPlayerId() {
        return this.playerId;
    },

    _loopButtonMarkerAnimation() {
        if (this.showing) {
            animate(this.infoAchievementsUnseenMarkerIcon[0], {
                keyframes: [{ rotate: 25 }, { rotate: -25 }],
                duration: 800,
                ease: UIConstants.EASE_DEFAULT,
                onComplete: () => {
                    if (this.showing) {
                        this._loopButtonMarkerAnimation();
                    }
                }
            });
        }
    },

    _loopShopButtonFlickerAnimation() {
        if (this.flickerTimeout) {
            clearTimeout(this.flickerTimeout);
            this.flickerTimeout = null;
        }

        if (this.showing) {
            this.flickerTimeout = setTimeout(() => {
                this.infoShop.toggleClass("flicker");
                let time = 0;
                const flickers = 3 + (Math.random() > 0.8 ? 2 : 0);
                for (let i = 0; i < flickers; ++i) {
                    time += 50 + Math.floor(Math.random() * 50);
                    setTimeout(() => {
                        this.infoShop.toggleClass("flicker");
                        if (this.showing) {
                            this._loopShopButtonFlickerAnimation();
                        }
                    }, time);
                }
            }, 4000 + Math.floor(Math.random() * 3000));
        }
    },

    _hideAllButtonsAndInfo() {
        this.infoGoldAndDiamondTableRow.hide();
        this.infoAdminLookup.hide();
        this.infoFavouriteStarOn.hide();
        this.infoFavouriteStarOff.hide();
        this.infoGameJoin.hide();
        this.infoGameJoinQueue.hide();
        this.infoChat.hide();
        this.infoSignUp.hide();
        this.infoShop.hide();
        this.infoGarage.hide();
        this.infoAchievements.hide();
        this.infoMazeCreator.hide();
        this.infoAccount.hide();
        this.infoAdmin.hide();
        this.infoLogOut.hide();
    },

    _showRelevantButtonsAndInfo() {
        const isAuthenticatedUser = Users.isAuthenticatedUser(this.playerId);
        const isGuestUser = Users.isGuestUser(this.playerId);

        if (!isAuthenticatedUser && !isGuestUser) {
            if (Users.getHighestGmLevel() >= UIConstants.ADMIN_LEVEL_PLAYER_LOOKUP) {
                this.infoAdminLookup.show();
                this.infoAdminLookup.addClass("disabled");
            }
            this.infoFavouriteStarOff.show();
            this.infoFavouriteStarOff.addClass("disabled");
            this.infoGameJoin.show();
            this.infoGameJoin.addClass("disabled");
            this.infoChat.show();
            this.infoChat.addClass("disabled");

            this.info.removeClass("localPlayer");
        } else {
            this.infoGoldAndDiamondTableRow.show();
            this.infoDiamondSvg.clear();
            this.infoGoldSvg.clear();

            this.info.addClass("localPlayer");

            if (isGuestUser) {
                this.infoSignUp.show();

                this.infoLogOut.off("mouseup").on("mouseup", event => {
                    if (this.showing) {
                        if (!$(event.currentTarget).hasClass("disabled")) {
                            this.hide();
                            // Submit delete guest request.
                            Backend.deleteGuest(this.playerId, Caches.getCurrencyCache())
                                .then(result => {
                                    if (typeof result === "object") {
                                        // Remove guest user
                                        Users.removeGuestUser(result.playerId);
                                    } else {
                                        TankTrouble.ErrorBox.show(result);
                                    }
                                });
                        }
                    }
                }).show();
            } else {
                Backend.getPlayerDetails(this.playerId, Caches.getPlayerDetailsCache())
                    .then(result => {
                        if (typeof result === "object") {
                            if (result.getGmLevel() >= UIConstants.ADMIN_LEVEL_DASHBOARD) {
                                this.infoAdmin.off("mouseup").on("mouseup", event => {
                                    if (this.showing) {
                                        this.hide();
                                        OverlayManager.pushOverlay(
                                            TankTrouble.AdminDashboardOverlay,
                                            { adminId: this.playerId }
                                        );
                                    }
                                }).show();
                            } else if (result.getGmLevel() === UIConstants.ADMIN_LEVEL_ACCEPT_GUIDELINES) {
                                this.infoAdmin.off("mouseup").on("mouseup", event => {
                                    if (this.showing) {
                                        this.hide();
                                        OverlayManager.pushOverlay(
                                            TankTrouble.AdminAcceptGuidelinesOverlay,
                                            { adminId: this.playerId, page: "intro" }
                                        );
                                    }
                                }).show();
                            }
                        }
                    });

                this.infoAccount.show();

                this.infoLogOut.off("mouseup").on("mouseup", event => {
                    if (this.showing) {
                        if (!$(event.currentTarget).hasClass("disabled")) {
                            this.hide();
                            // Submit deauthenticate request.
                            Backend.deauthenticate(this.playerId, Caches.getEmailCache(), Caches.getCurrencyCache())
                                .then(result => {
                                    if (typeof result === "object") {
                                        // Remove deauthenticated user
                                        Users.removeAuthenticatedUser(result.playerId);
                                    } else {
                                        TankTrouble.ErrorBox.show(result);
                                    }
                                });
                        }
                    }
                }).show();
            }

            this._updateLogInAndOutStatus();

            Backend.getCurrency(this.playerId, Caches.getCurrencyCache())
                .then(result => {
                    this._spawnDiamondSparkle(this.infoDiamondTableCell);
                    this._spawnGoldSparkle(this.infoGoldTableCell);

                    let diamonds = "N/A";

                    if (typeof result === "object") {
                        diamonds = result.getDiamonds();
                    }
                    const diamondsTextOutline = this.infoDiamondSvg.text(UIConstants.TANK_INFO_MAX_NUMBER_WIDTH - 1, 22, diamonds.toString(), { textAnchor: "end", fontFamily: "Arial Black", fontSize: 14, fill: "none", stroke: "black", strokeLineJoin: "round", strokeWidth: 3, letterSpacing: 1 });
                    const diamondsText = this.infoDiamondSvg.text(UIConstants.TANK_INFO_MAX_NUMBER_WIDTH - 1, 22, diamonds.toString(), { textAnchor: "end", fontFamily: "Arial Black", fontSize: 14, fill: "white", letterSpacing: 1 });

                    const diamondsLength = Utils.measureSVGText(diamonds.toString(), { fontFamily: "Arial Black", fontSize: 14 });

                    // Plus seven to account for stroke width.
                    let scaleAndTranslate = Utils.getSVGScaleAndTranslateToFit(UIConstants.TANK_INFO_MAX_NUMBER_WIDTH, diamondsLength + 7, 34, "right");

                    this.infoDiamondSvg.configure(diamondsTextOutline, { transform: scaleAndTranslate });
                    this.infoDiamondSvg.configure(diamondsText, { transform: scaleAndTranslate });

                    let gold = "N/A";

                    if (typeof result === "object") {
                        gold = result.getGold();
                    }
                    const goldTextOutline = this.infoGoldSvg.text(1, 22, gold.toString(), { textAnchor: "start", fontFamily: "Arial Black", fontSize: 14, fill: "none", stroke: "black", strokeLineJoin: "round", strokeWidth: 3, letterSpacing: 1 });
                    const goldText = this.infoGoldSvg.text(1, 22, gold.toString(), { textAnchor: "start", fontFamily: "Arial Black", fontSize: 14, fill: "white", letterSpacing: 1 });

                    const goldLength = Utils.measureSVGText(gold.toString(), { fontFamily: "Arial Black", fontSize: 14 });

                    // Plus seven to account for stroke width.
                    scaleAndTranslate = Utils.getSVGScaleAndTranslateToFit(UIConstants.TANK_INFO_MAX_NUMBER_WIDTH, goldLength + 7, 34, "left");

                    this.infoGoldSvg.configure(goldTextOutline, { transform: scaleAndTranslate });
                    this.infoGoldSvg.configure(goldText, { transform: scaleAndTranslate });
                });

            this.infoShop.show();
            this._loopShopButtonFlickerAnimation();

            this.infoGarage.show();
            this.infoAchievements.show();
            this.infoMazeCreator.show();
        }
    },

    _lookup() {
        this.hide();
        OverlayManager.pushOverlay(
            TankTrouble.AdminPlayerLookupOverlay,
            { adminId: Users.getHighestGmUser(), playerId: this.playerId }
        );
    },

    _setFavourited(value) {
        Backend.setFavourited(this.playerId, value, Users.getAllPlayerIds(), Caches.getFavouritesCache())
            .then(result => {
                if (typeof result === "boolean") {
                    this._updateFavouriteStatus();
                } else {
                    this.hide();
                    TankTrouble.ErrorBox.show(result);
                }
            });
    },

    _updateLogInAndOutStatus() {
        if (ClientManager.getClient().isPlayerAuthenticating(this.playerId)) {
            this.infoLogOut.addClass("disabled");
            this.infoLogOut.tooltipster("content", "Please wait");
            this.infoLogOut.tooltipster("option", "theme", []);
        } else {
            this.infoLogOut.removeClass("disabled");
            if (Users.isGuestUser(this.playerId)) {
                if (this.username) {
                    this.infoLogOut.tooltipster("content", `WARNING: If you leave you will lose all progress with ${this.username}`);
                } else {
                    this.infoLogOut.tooltipster("content", "WARNING: If you leave you will lose all progress with this guest");
                }
                this.infoLogOut.tooltipster("option", "theme", "tooltipster-error");
            } else {
                this.infoLogOut.tooltipster("content", "Log out");
                this.infoLogOut.tooltipster("option", "theme", []);
            }
        }
    },

    _updateFavouriteStatus() {
        let favourite = false;

        // Check for all users if this tank is a favourite.
        const playerIds = Users.getAllPlayerIds();

        // Only check if tank is not local.
        if (playerIds.includes(this.playerId)) {
            return;
        }

        const favouritePlayerIds = [];
        const favouritesPromises = playerIds.map(playerId => {
            return Backend.getFavourites(playerId, Caches.getFavouritesCache())
                .then(result => {
                    if (Array.isArray(result)) {
                        favouritePlayerIds.push(...result);
                    }
                })
                .catch(() => {});
        });

        // When we have all responses, check if the tank is a favourite.
        Promise.all(favouritesPromises).then(() => {
            for (let j = 0; j < favouritePlayerIds.length; ++j) {
                if (favouritePlayerIds[j] === this.playerId) {
                    favourite = true;
                    break;
                }
            }

            if (favourite) {
                this.infoFavouriteStarOn.show().removeClass("disabled");
                this.infoFavouriteStarOff.hide();
            } else {
                this.infoFavouriteStarOn.hide();
                this.infoFavouriteStarOff.show().removeClass("disabled");
            }
        });
    },

    _updateJoinGameStatus() {
        // Check if this tank can be joined in battle (make sure there is room for all users).
        const playerIds = Users.getAllPlayerIds();

        // Only check if tank is not local.
        if (!playerIds.includes(this.playerId)) {
            // FIXME Actually do the check!
            //this.infoGameJoin.removeClass("disabled");
        }
    },

    _updateChatStatus() {
        // Check if this tank can be chatted to.
        const playerIds = Users.getAllPlayerIds();

        // Only check if tank is not local.
        if (playerIds.includes(this.playerId)) {
            return;
        }

        // FIXME Actually do the check!

        if (Users.getAuthenticatedPlayerIds().length > 0) {
            this.infoChat.removeClass("disabled");
        }
    },

    // FIXME Move this to other class for reuse.
    _spawnGoldSparkle(goldElement) {
        if (!goldElement.is(":visible")) {
            return;
        }

        // 16 is the radius of an unscaled coin.
        const distance = 15 - (Math.random() * 2);
        const angle = Math.random() * 2.0 * Math.PI;

        // 20 is half the width of a sparkle. 38 and 34 are the width and height og the gold image.
        let sparkleX = -20 + (38 / 2) + (Math.cos(angle) * distance * 0.8);
        const sparkleY = -20 + (34 / 2) + (Math.sin(angle) * distance);

        // Skew the sparkle position a little to match coin.
        sparkleX += (sparkleY + 20) * 0.2;

        const sparkle = $(`<img class='sparkle' ${Images.attributes("atlases/game/sparkle.png")}>`);
        sparkle.css({ left: sparkleX, top: sparkleY });
        utils.set(sparkle[0], { scale: 0.2, rotate: Math.floor(Math.random() * 180) });

        goldElement.append(sparkle);

        animate(sparkle[0], {
            keyframes: [
                { scale: 1, rotate: "+=90" },
                { scale: 0, rotate: "+=90" }
            ],
            duration: 2 * UIConstants.SPARKLE_ANIMATION_TIME,
            ease: "linear",
            onComplete: () => {
                sparkle.remove();
            }
        });

        if (this.goldSparkleTimeout) {
            clearTimeout(this.goldSparkleTimeout);
            this.goldSparkleTimeout = null;
        }

        this.goldSparkleTimeout = setTimeout(() => {
            this._spawnGoldSparkle(goldElement);
        }, UIConstants.GOLD_SPARKLE_MIN_INTERVAL_TIME + (Math.random() * (UIConstants.GOLD_SPARKLE_MAX_INTERVAL_TIME - UIConstants.GOLD_SPARKLE_MIN_INTERVAL_TIME)));
    },

    // FIXME Move this to other class for reuse.
    _spawnDiamondSparkle(diamondElement) {
        if (!diamondElement.is(":visible")) {
            return;
        }

        // 32 is the height of the diamond.
        const distance = (32 / 2) - 2 - (Math.random() * 2);
        const angle = Math.random() * 2.0 * Math.PI;

        // 20 is half the width of a sparkle. 38 and 34 are width and height of the diamond image. 5 is the diamond offset.
        const sparkleX = -20 + (38 / 2) + 5 + (Math.cos(angle) * distance * 0.5);
        const sparkleY = -20 + (34 / 2) + (Math.sin(angle) * distance);

        const sparkle = $(`<img class='sparkle' ${Images.attributes("atlases/game/sparkle.png")}>`);
        sparkle.css({ right: sparkleX, top: sparkleY });
        utils.set(sparkle[0], { scale: 0.2, rotate: Math.floor(Math.random() * 180) });

        diamondElement.append(sparkle);

        animate(sparkle[0], {
            keyframes: [
                { scale: 1, rotate: "+=90" },
                { scale: 0, rotate: "+=90" }
            ],
            duration: 2 * UIConstants.SPARKLE_ANIMATION_TIME,
            ease: "linear",
            onComplete: () => {
                sparkle.remove();
            }
        });

        if (this.diamondSparkleTimeout) {
            clearTimeout(this.diamondSparkleTimeout);
            this.diamondSparkleTimeout = null;
        }

        this.diamondSparkleTimeout = setTimeout(() => {
            this._spawnDiamondSparkle(diamondElement);
        }, UIConstants.DIAMOND_SPARKLE_MIN_INTERVAL_TIME + (Math.random() * (UIConstants.DIAMOND_SPARKLE_MAX_INTERVAL_TIME - UIConstants.DIAMOND_SPARKLE_MIN_INTERVAL_TIME)));
    },

    _clientEventHandler(self, evt, data) {
        switch (evt) {
            case TTClient.EVENTS.PLAYERS_AUTHENTICATING:
            case TTClient.EVENTS.PLAYERS_AUTHENTICATED:
            {
                self._updateLogInAndOutStatus();
                break;
            }
        }
    },

    _notifyEventListeners(evt, data) {
        for (let i = 0; i < this.eventListeners.length; i++) {
            this.eventListeners[i].callback(this.eventListeners[i].context, evt, data);
        }
    }
};
